(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[15563],{

/***/ 92796:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support",
      function () {
        return __webpack_require__(39677);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ support; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./src/utils/Dropdown.js
var Dropdown = __webpack_require__(68722);
// EXTERNAL MODULE: ./src/utils/Transition.js
var utils_Transition = __webpack_require__(1193);
// EXTERNAL MODULE: ./constant/url.js
var url = __webpack_require__(99741);
// EXTERNAL MODULE: ./src/pages/api/api.js + 1 modules
var api = __webpack_require__(10107);
// EXTERNAL MODULE: ./constant/functions.js
var functions = __webpack_require__(60538);
// EXTERNAL MODULE: ./src/partials/UserMenu.js
var UserMenu = __webpack_require__(66846);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(9669);
// EXTERNAL MODULE: ./src/redux/features/users/userApi.js
var userApi = __webpack_require__(99226);
// EXTERNAL MODULE: ./src/components/Auth/Logout.js
var Logout = __webpack_require__(86197);
;// CONCATENATED MODULE: ./src/partials/UserMenu2.js












function UserMenu2_UserMenu2() {
    var ref = useGetUserDetailsQuery({}), userDetails = ref.data;
    var ref1 = useState(false), dropdownOpen = ref1[0], setDropdownOpen = ref1[1];
    var ref2 = useState(null), tenantDetails = ref2[0], setTenantDetails = ref2[1];
    var trigger = useRef(null);
    var dropdown = useRef(null);
    var router = useRouter();
    // close on click outside
    useEffect(function() {
        var clickHandler = function(param) {
            var target = param.target;
            if (!dropdown.current) return;
            if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
            setDropdownOpen(false);
        };
        document.addEventListener("click", clickHandler);
        return function() {
            return document.removeEventListener("click", clickHandler);
        };
    });
    // close if the esc key is pressed
    useEffect(function() {
        var keyHandler = function(param) {
            var keyCode = param.keyCode;
            if (!dropdownOpen || keyCode !== 27) return;
            setDropdownOpen(false);
        };
        document.addEventListener("keydown", keyHandler);
        return function() {
            return document.removeEventListener("keydown", keyHandler);
        };
    });
    // user Details and tenant details fetching
    useEffect(function() {
        if (getAuthKey() !== undefined) {
            var auth_key = getAuthKey();
            if (auth_key) {
                axios.get("/api/user_tenants_details", {
                    params: {
                        auth_key: getAuthKey()
                    }
                }).then(function(res) {
                    setTenantDetails(getSelectedTenantDetails(res.data.data.tenants));
                }).catch(function(err) {
                    var ref, ref1, ref2;
                    if ((err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.error) === null || ref2 === void 0 ? void 0 : ref2.message) == "unauthorized") {
                        window.location.reload();
                    } else {
                        var ref3, ref4, ref5, ref6, ref7, ref8;
                        (err === null || err === void 0 ? void 0 : (ref3 = err.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.error) === null || ref5 === void 0 ? void 0 : ref5.message) && alert(err === null || err === void 0 ? void 0 : (ref6 = err.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.error) === null || ref8 === void 0 ? void 0 : ref8.message);
                    }
                });
            }
        }
    }, [
        router
    ]);
    return userDetails && /*#__PURE__*/ _jsxs("div", {
        className: "relative inline-flex",
        children: [
            /*#__PURE__*/ _jsxs("button", {
                ref: trigger,
                className: "inline-flex justify-center items-center group",
                "aria-haspopup": "true",
                onClick: function() {
                    return setDropdownOpen(!dropdownOpen);
                },
                "aria-expanded": dropdownOpen,
                children: [
                    userDetails.profile_pic ? /*#__PURE__*/ _jsx("img", {
                        className: "w-8 h-8 rounded-full",
                        src: userDetails.profile_pic,
                        width: "32",
                        height: "32",
                        alt: "User"
                    }) : /*#__PURE__*/ _jsx("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "w-8 h-8 rounded-full text-gray-700",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ _jsx("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center truncate",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "truncate ml-2 text-sm font-medium group-hover:text-gray-800",
                                children: userDetails.name
                            }),
                            /*#__PURE__*/ _jsx("svg", {
                                className: "w-3 h-3 flex-shrink-0 ml-1 fill-current text-gray-400",
                                viewBox: "0 0 12 12",
                                children: /*#__PURE__*/ _jsx("path", {
                                    d: "M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Transition, {
                className: "origin-top-right z-10 absolute top-full right-0 min-w-[150px] bg-white border border-gray-200 py-1.5 rounded shadow-lg overflow-hidden mt-1",
                show: dropdownOpen,
                enter: "transition ease-out duration-200 transform",
                enterStart: "opacity-0 -translate-y-2",
                enterEnd: "opacity-100 translate-y-0",
                leave: "transition ease-out duration-200",
                leaveStart: "opacity-100",
                leaveEnd: "opacity-0",
                children: /*#__PURE__*/ _jsx("div", {
                    ref: dropdown,
                    onFocus: function() {
                        return setDropdownOpen(true);
                    },
                    onBlur: function() {
                        return setDropdownOpen(false);
                    },
                    children: /*#__PURE__*/ _jsxs("ul", {
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(Link, {
                                    href: "https://superadmin.tradly.app",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        target: "_blank",
                                        className: " font-medium text-sm text-indigo-500 hover:text-indigo-600 flex items-center py-1 px-3",
                                        onClick: function() {
                                            return setDropdownOpen(!dropdownOpen);
                                        },
                                        children: "SuperAdmin"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(Link, {
                                    href: "/workspace",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        target: "_blank",
                                        className: " font-medium text-sm text-indigo-500 hover:text-indigo-600 flex items-center py-1 px-3",
                                        onClick: function() {
                                            return setDropdownOpen(!dropdownOpen);
                                        },
                                        children: "Workspace"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                onClick: function() {
                                    logout_tradly();
                                },
                                children: /*#__PURE__*/ _jsx("a", {
                                    className: " font-medium text-sm text-indigo-500 hover:text-indigo-600 flex items-center py-1 px-3 cursor-pointer",
                                    children: "Logout"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx("a", {
                                    className: " font-normal text-sm text-gray-400 italic flex items-center py-1 px-3 cursor-text",
                                    children: tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.id
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var partials_UserMenu2 = ((/* unused pure expression or super */ null && (UserMenu2_UserMenu2)));

;// CONCATENATED MODULE: ./src/partials/Header2.js












function Header2(param) {
    var _hasNav = param.hasNav, hasNav = _hasNav === void 0 ? false : _hasNav, navIsOpen = param.navIsOpen, onNavToggle = param.onNavToggle, title = param.title, section = param.section;
    var ref = useState(false), mobileNavOpen = ref[0], setMobileNavOpen = ref[1];
    var ref1 = useState(true), top = ref1[0], setTop = ref1[1];
    var ref2 = useState(false), hideNt = ref2[0], setHideNt = ref2[1];
    var trigger = useRef(null);
    var mobileNav = useRef(null);
    //
    var router = useRouter();
    // close the mobile menu on click outside
    useEffect(function() {
        var clickHandler = function(param) {
            var target = param.target;
            if (!mobileNav.current || !trigger.current) return;
            if (!mobileNavOpen || mobileNav.current.contains(target) || trigger.current.contains(target)) return;
            setMobileNavOpen(false);
        };
        document.addEventListener("click", clickHandler);
        return function() {
            return document.removeEventListener("click", clickHandler);
        };
    });
    //close nav after load new page
    useEffect(function() {
        var handleRouteChange = function handleRouteChange() {
            setMobileNavOpen(false);
        };
        if (!mobileNav) return;
        Router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            Router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        mobileNav
    ]);
    // close the mobile menu if the esc key is pressed
    useEffect(function() {
        var keyHandler = function(param) {
            var keyCode = param.keyCode;
            if (!mobileNavOpen || keyCode !== 27) return;
            setMobileNavOpen(false);
        };
        document.addEventListener("keydown", keyHandler);
        return function() {
            return document.removeEventListener("keydown", keyHandler);
        };
    });
    // detect whether user has scrolled the page down by 10px
    useEffect(function() {
        var scrollHandler = function() {
            window.pageYOffset > 10 ? setTop(false) : setTop(true);
        };
        window.addEventListener("scroll", scrollHandler);
        return function() {
            return window.removeEventListener("scroll", scrollHandler);
        };
    }, [
        top
    ]);
    //
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("header", {
            className: "  block  bg-white  blur shadow-lg md:h-20 w-full z-30 md:bg-opacity-90 transition duration-300 ease-in-out ".concat(!top && "bg-white  blur  shadow-lg"),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "max-w-6xl mx-auto px-5 sm:px-6",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center justify-between h-16 md:h-20",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex-shrink-0 mr-4",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    href: "/",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "block cursor-pointer",
                                        "aria-label": "Tradly",
                                        children: /*#__PURE__*/ _jsx("a", {
                                            children: /*#__PURE__*/ _jsxs("svg", {
                                                width: "50",
                                                height: "50",
                                                viewBox: "0 0 126 126",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ _jsx("path", {
                                                        "fill-rule": "evenodd",
                                                        "clip-rule": "evenodd",
                                                        d: "M63 0C97.7939 0 126 28.2061 126 63C126 97.7939 97.7939 126 63 126C28.2061 126 0 97.7939 0 63C0 28.2061 28.2061 0 63 0Z",
                                                        fill: "url(#paint0_linear)"
                                                    }),
                                                    /*#__PURE__*/ _jsx("path", {
                                                        opacity: "0.5",
                                                        "fill-rule": "evenodd",
                                                        "clip-rule": "evenodd",
                                                        d: "M63 119C93.9279 119 119 93.9279 119 63C119 32.0721 93.9279 7 63 7C32.0721 7 7 32.0721 7 63C7 93.9279 32.0721 119 63 119Z",
                                                        stroke: "white",
                                                        "stroke-width": "1.4"
                                                    }),
                                                    /*#__PURE__*/ _jsx("path", {
                                                        opacity: "0.5",
                                                        "fill-rule": "evenodd",
                                                        "clip-rule": "evenodd",
                                                        d: "M63 105C86.196 105 105 86.196 105 63C105 39.804 86.196 21 63 21C39.804 21 21 39.804 21 63C21 86.196 39.804 105 63 105Z",
                                                        stroke: "white",
                                                        "stroke-width": "1.4"
                                                    }),
                                                    /*#__PURE__*/ _jsx("path", {
                                                        d: "M108.282 44.2442C105.799 38.2551 102.162 32.8652 97.6482 28.3518C88.7809 19.4845 76.5309 14 63 14C49.469 14 37.219 19.4845 28.3517 28.3518C23.8383 32.8652 20.2012 38.2551 17.7178 44.2442",
                                                        stroke: "white",
                                                        "stroke-width": "15.4",
                                                        "stroke-linecap": "round"
                                                    }),
                                                    /*#__PURE__*/ _jsx("path", {
                                                        d: "M63.0001 14.0001V111.222",
                                                        stroke: "white",
                                                        "stroke-width": "15.4",
                                                        "stroke-linecap": "round"
                                                    }),
                                                    /*#__PURE__*/ _jsx("defs", {
                                                        children: /*#__PURE__*/ _jsxs("linearGradient", {
                                                            id: "paint0_linear",
                                                            x1: "126",
                                                            y1: "0",
                                                            x2: "126",
                                                            y2: "126",
                                                            gradientUnits: "userSpaceOnUse",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("stop", {
                                                                    "stop-color": "#2BDBC0"
                                                                }),
                                                                /*#__PURE__*/ _jsx("stop", {
                                                                    offset: "1",
                                                                    "stop-color": "#13B58C"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs("nav", {
                                className: " flex md:flex-grow",
                                children: [
                                    /*#__PURE__*/ _jsx("ul", {
                                        className: "flex flex-grow justify-end flex-wrap items-center",
                                        children: /*#__PURE__*/ _jsx("li", {})
                                    }),
                                    getAuthKey() === undefined ? /*#__PURE__*/ _jsxs("ul", {
                                        className: "flex flex-grow justify-end flex-wrap items-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: "/signin?to=".concat(site_url).concat(router.asPath),
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        className: "font-medium text-gray-600 hover:text-gray-900 px-5 py-3 flex items-center transition duration-150 ease-in-out",
                                                        children: "Sign in"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: "/signup",
                                                    children: /*#__PURE__*/ _jsxs("a", {
                                                        className: "btn-sm text-gray-200 bg-gray-900 hover:bg-gray-800 ml-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: "Try Tradly Free"
                                                            }),
                                                            /*#__PURE__*/ _jsx("svg", {
                                                                className: "w-3 h-3 fill-current text-gray-400 flex-shrink-0 ml-2 -mr-1",
                                                                viewBox: "0 0 12 12",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ _jsx("path", {
                                                                    d: "M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z",
                                                                    fillRule: "nonzero"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ _jsx("ul", {
                                        className: "flex flex-grow justify-end flex-wrap items-center",
                                        children: /*#__PURE__*/ _jsx(UserMenu2, {
                                            align: "right"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    " ",
                    hasNav && /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center p-4 border-b border-gray-900/10 md:hidden dark:border-gray-50/[0.06]",
                        children: [
                            /*#__PURE__*/ _jsxs("button", {
                                type: "button",
                                onClick: function() {
                                    return onNavToggle(!navIsOpen);
                                },
                                className: "text-gray-500 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "sr-only",
                                        children: "Navigation"
                                    }),
                                    /*#__PURE__*/ _jsx("svg", {
                                        width: "24",
                                        height: "24",
                                        children: /*#__PURE__*/ _jsx("path", {
                                            d: "M5 6h14M5 12h14M5 18h14",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round"
                                        })
                                    })
                                ]
                            }),
                            title && /*#__PURE__*/ _jsxs("ol", {
                                className: "ml-4 flex text-sm leading-6 whitespace-nowrap min-w-0",
                                children: [
                                    section && /*#__PURE__*/ _jsxs("li", {
                                        className: "flex items-center",
                                        children: [
                                            section,
                                            /*#__PURE__*/ _jsx("svg", {
                                                width: "3",
                                                height: "6",
                                                "aria-hidden": "true",
                                                className: "mx-3 overflow-visible text-gray-400",
                                                children: /*#__PURE__*/ _jsx("path", {
                                                    d: "M0 0L3 3L0 6",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("li", {
                                        className: "font-semibold text-gray-900 truncate dark:text-gray-200",
                                        children: title
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var partials_Header2 = ((/* unused pure expression or super */ null && (Header2)));

;// CONCATENATED MODULE: ./src/pages/support.js






var Support = function() {
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        // Needed for cleaning residue left by the external script that can only be removed by reloading the page
        var onRouterChange = function() {
            var elements1 = document.getElementsByClassName("fs_17c82cd4bcd2a15b5f746294b40b40647c1005006a433be6883a34225a03956c");
            var elements2 = document.getElementsByClassName("fs-webform-loader");
            while(elements1.length > 0){
                elements1[0].parentNode.removeChild(elements1[0]);
            }
            while(elements2.length > 0){
                elements2[0].parentNode.removeChild(elements2[0]);
            }
        };
        router.events.on("routeChangeStart", onRouterChange);
        return function() {
            router.events.off("routeChangeStart", onRouterChange);
        };
    }, [
        router
    ]);
    (0,react.useEffect)(function() {
        if (router.pathname === "/support") {
            var script = document.getElementsByClassName("fs_17c82cd4bcd2a15b5f746294b40b40647c1005006a433be6883a34225a03956c");
            // if (script.length === 0) {
            //   router.reload()
            // }
            setTimeout(function() {
                if (script.length === 0) {
                    router.reload();
                }
            }, 1000);
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    })
                ]
            }),
            " ",
            router.pathname === "/support" && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                strategy: "afterInteractive",
                src: "https://istrata.myfreshworks.com/crm/sales/web_forms/17c82cd4bcd2a15b5f746294b40b40647c1005006a433be6883a34225a03956c/form.js",
                crossorigin: "anonymous",
                id: "fs_17c82cd4bcd2a15b5f746294b40b40647c1005006a433be6883a34225a03956c"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " relative pt-[20px] z-[-1] overflow-hidden"
            })
        ]
    });
};
/* harmony default export */ var support = (Support);


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [49774,92888,40179], function() { return __webpack_exec__(92796); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);